<template>
  <div id="main">
    <div class="wrapper" v-if="$store.state.isLoggedIn">
      <template>
        <app-header @onTrigger="drawer = !drawer"></app-header>
        <v-navigation-drawer
          id="navigation"
          fixed
          v-model="drawer"
          dark
          app
          :class="{ menu: true, default: isDefaultTheme, primary: !isDefaultTheme }"
        >
          <v-layout style="justify-content: center">
            <v-flex v-show="!mini">
              <v-btn fab flat dark small @click="onGoHome">
                <v-icon>fas fa-th</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right" style="display: contents">
              <div class="text-xs-right hidden-sm-and-down">
                <router-link :to="'/' + $i18n.locale() + '/home?page=platformupdate'">
                  <v-btn fab flat dark small @click="closeBadge">
                    <v-badge left v-model="showBadge">
                      <template v-slot:badge>
                        <span>3</span>
                      </template>
                      <v-icon> fas fa-bell </v-icon>
                    </v-badge>
                  </v-btn>
                </router-link>
              </div>
              <v-btn fab flat dark small @click="drawer = false" class="hidden-sm-and-up">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <ul class="home-m menu-list"></ul>
          <div class="text-xs-center">
            <template>
              <SocialBadge :value="selectedBot.packages"></SocialBadge>
            </template>

            <div class="avatar mb-2">
              <div class="avatar-img" style="position: relative">
                <div style="position: absolute; right: -5px; top: -5px">
                  <template
                    v-if="
                      !selectedBot.pagerole ||
                        (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                    "
                  ></template>
                </div>
                <input
                  class="d-none"
                  type="file"
                  ref="uploadProfile"
                  accept=".png, .jpg, .jpeg"
                  @change="handlePreviewProfile"
                />
                <v-avatar class="avatar-profile upload" :size="mini ? '60px' : '100px'">
                  <img
                    class="responsive-img circle cover"
                    style="min-width: 100%"
                    alt
                    @error="onError"
                    :src="
                      selectedBot.pagelogo ||
                        'https://graph.facebook.com/' +
                          selectedBot.pageid +
                          '/picture?width=100&height=100&SameSite=None'
                    "
                    :class="{
                      'bot-active': selectedBot.status,
                      'bot-inactive': !selectedBot.status
                    }"
                  />
                  <div class="avatar-profile-upload" @click="handleUploadProfile">
                    <v-icon :size="mini ? '32px' : '50px'">camera_alt</v-icon>
                  </div>
                </v-avatar>
              </div>
            </div>

            <div style="margin-bottom: 15px" v-if="!mini">
              <router-link :to="'/' + $i18n.locale() + '/billing'">
                <div class="status active" v-if="selectedBot.status">
                  <i class="fas fa-play"></i>
                  <span style="margin-left: 5px">{{ $t('active') }}</span>
                </div>
                <div class="status inactive" v-else>
                  <i class="fas fa-pause"></i>
                  <span style="margin-left: 5px">{{ $t('inactive') }}</span>
                </div>
              </router-link>
            </div>

            <v-menu
              offset-y
              open-on-hover
              offset-overflow
              max-height="200"
              v-if="!$store.state.userid.includes('zwiz')"
            >
              <template v-slot:activator="{ on }">
                <v-btn round outline v-on="on" class="select-page-list" dark small>
                  <div
                    class="text-truncate"
                    style="
                      display: inline-block;
                      word-break: break-all;
                      max-width: 150px;
                      vertical-align: middle;
                    "
                  >
                    <template v-if="selectedBot">{{ selectedBot.pagename }}</template>
                  </div>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  class="main-menu"
                  v-for="(item, index) in optionBotlist"
                  :key="index"
                  @click="selectBot(item)"
                >
                  <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

            <template v-if="account_package.includes('enterprise')">
              <v-chip color="blue-grey darken-1" small>
                <v-icon class="mr-2" small>grade</v-icon>
                {{ $t('Enterprise') }} ({{ selectedBot.expriedDate }} {{ $t('Day(s)') }})
              </v-chip>
            </template>
            <template
              v-else-if="
                account_package.includes('advanced') ||
                  account_package.includes('premium') ||
                  account_package.includes('old_premium') ||
                  account_package.includes('business')
              "
            >
              <div>
                <span
                  v-if="alertExpSet"
                  class="alertExpDate active"
                  style="cursor: pointer"
                  @click="modalDialog = true"
                >
                  <i
                    class="material-icons"
                    style="vertical-align: middle; color: red; font-size: 30px"
                    v-show="alertExp"
                    >error_outline</i
                  >
                  <i
                    class="material-icons"
                    style="vertical-align: middle; color: red; font-size: 30px"
                    v-show="!alertExp"
                    >error</i
                  >
                </span>

                <template v-if="account_package.includes('business')">
                  <router-link :to="'/' + $i18n.locale() + '/upgrade'">
                    <div>
                      <v-chip color="#B01B5D" small>
                        <v-icon class="mr-2">diamond</v-icon>
                        <span v-if="!mini">
                          {{
                            $t('Business remain {num} day(s)', {
                              num: selectedBot.businessExpriedDate
                            })
                          }}
                        </span>
                        <span v-else>{{ selectedBot.businessExpriedDate }} </span>
                      </v-chip>
                    </div>
                  </router-link>
                  <!-- </a> -->
                </template>
                <template
                  v-if="
                    account_package.includes('advanced') &&
                      selectedBot.advancedExpriedDate != selectedBot.businessExpriedDate
                  "
                >
                  <!-- <a href="https://m.me/zwizai?ref=lineoaadvanced" target="_blank"> -->
                  <router-link :to="'/' + $i18n.locale() + '/upgrade'">
                    <v-chip color="amber" small>
                      <i class="fas fa-crown mr-2"></i>
                      <span v-if="!mini">
                        {{
                          $t('Advanced remain {num} day(s)', {
                            num: selectedBot.advancedExpriedDate
                          })
                        }}
                      </span>
                      <span v-else>{{ selectedBot.advancedExpriedDate }} </span>
                    </v-chip>
                  </router-link>
                  <!-- </a> -->
                </template>
                <template
                  v-if="
                    (account_package.includes('premium') ||
                      account_package.includes('old_premium')) &&
                      selectedBot.expriedDate != selectedBot.advancedExpriedDate
                  "
                >
                  <router-link :to="'/' + $i18n.locale() + '/upgrade'">
                    <v-chip color="info" small>
                      <v-icon class="mr-2" small>grade</v-icon>
                      <span v-if="!mini"
                        >{{ $t('Premium remain {num} day(s)', { num: selectedBot.expriedDate }) }}
                      </span>
                      <span v-else>{{ selectedBot.expriedDate }} </span>
                    </v-chip>
                  </router-link>
                </template>

                <template
                  v-if="
                    !account_package.includes('advanced') &&
                      !account_package.includes('business') &&
                      selectedBot.livechatExpriedDate &&
                      selectedBot.livechatExpriedDate > 0
                  "
                >
                  <router-link :to="'/' + $i18n.locale() + '/upgrade'">
                    <div>
                      <v-chip color="#ed1e79" small>
                        <span v-if="!mini">
                          {{
                            $t('Livechat remain {num} day(s)', {
                              num: selectedBot.livechatExpriedDate
                            })
                          }}
                        </span>
                        <span v-else>{{ selectedBot.livechatExpriedDate }} </span>
                      </v-chip>
                    </div>
                  </router-link>
                </template>

                <template
                  v-if="
                    !account_package.includes('business') &&
                      selectedBot.googleExpriedDate &&
                      selectedBot.googleExpriedDate > 0
                  "
                >
                  <router-link :to="'/' + $i18n.locale() + '/upgrade'">
                    <div>
                      <v-chip color="#ffb306" small>
                        <span v-if="!mini">
                          {{
                            $t('Google remain {num} day(s)', {
                              num: selectedBot.googleExpriedDate
                            })
                          }}
                        </span>
                        <span v-else>{{ selectedBot.googleExpriedDate }} </span>
                      </v-chip>
                    </div>
                  </router-link>
                </template>

                <template
                  v-if="
                    !account_package.includes('business') &&
                      selectedBot.whatsappExpriedDate &&
                      selectedBot.whatsappExpriedDate > 0
                  "
                >
                  <router-link :to="'/' + $i18n.locale() + '/upgrade'">
                    <div>
                      <v-chip color="#0bb902" small>
                        <span v-if="!mini">
                          {{
                            $t('Whatsapp remain {num} day(s)', {
                              num: selectedBot.whatsappExpriedDate
                            })
                          }}
                        </span>
                        <span v-else>{{ selectedBot.whatsappExpriedDate }} </span>
                      </v-chip>
                    </div>
                  </router-link>
                </template>
              </div>
            </template>
            <template v-else>
              <span style="cursor: pointer" @click="modalDialog = true">
                <i
                  class="material-icons"
                  style="vertical-align: middle; color: red; font-size: 30px"
                  >error_outline</i
                >
              </span>
              <router-link
                :to="'/' + $i18n.locale() + '/upgrade?tab=package'"
                class="link link-white decorate-none"
                style="font-size: 18px"
              >
                <v-chip color="indigo lighten-4" small>
                  <v-icon class="mr-2" small>lock</v-icon>
                  {{ $t('You are using FREE package') }}
                </v-chip>
              </router-link>
            </template>
          </div>

          <div class="mt-1">
            <div
              v-if="
                $store.state.centralPage.includes(selectedBot.pageid) &&
                  $store.state.privilege.role === 'admin' &&
                  $store.state.loginChannel === 'account'
              "
            >
              <v-list>
                <template>
                  <v-list-tile
                    :to="'/' + $i18n.locale() + '/template?tab=ecommerce-order-summary'"
                    class="main-menu"
                  >
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/shop.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Order Summary') }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="logout" class="main-menu">
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/sign-out.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Sign Out') }}</v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </div>
            <div v-else>
              <v-list>
                <template
                  v-if="
                    !selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                >
                  <v-list-tile
                    v-if="$store.state.centralPage.includes(selectedBot.pageid) && isZwizAdmin"
                    :to="'/' + $i18n.locale() + '/agentmanagement'"
                    class="main-menu"
                  >
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/user.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Users management') }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="'/' + $i18n.locale() + '/home'" class="main-menu">
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/home.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Home') }}</v-list-tile-title>
                  </v-list-tile>

                  <!-- <v-list-tile :to="'/' + $i18n.locale() + '/chatbot'" class="main-menu">
                    <v-list-tile-action>
       
                      <v-icon>message</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Chatbot') }}</v-list-tile-title>
                  </v-list-tile> -->
                  <!-- <v-list-group prepend-icon="message" @click="$router.push(`/${currentLang}/chatbot?tab=WelcomeMessage`)" v-model="group_open"> -->
                  <!-- <template v-slot:activator> -->
                  <template v-if="isShowMenu('chatbot')">
                    <v-list-tile class="main-menu" :to="'/' + $i18n.locale() + '/chatbot'">
                      <v-list-tile-action>
                        <v-icon>message</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ $t('Chatbot') }}</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <!-- </template> -->
                  <!-- <v-list-tile
                      :style="$route.query.tab === `WelcomeMessage` ? 'background: #f44788;' : ''"
                      class="main-menu"
                      @click="
                        if ($route.path !== `/${currentLang}/chatbot?tab=WelcomeMessage`)
                          $router.push(`/${currentLang}/chatbot?tab=WelcomeMessage`)
                      "
                      v-if="isShowMenu('welcome')"
                    >
                      <v-list-tile-action> </v-list-tile-action>
                      <v-list-tile-title>{{ $t('Welcome Message') }}</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                      :style="$route.query.tab === `Conversation` ? 'background: #f44788;' : ''"
                      class="main-menu"
                      @click="
                        if ($route.path !== `/${currentLang}/chatbot?tab=Conversation`)
                          $router.push(`/${currentLang}/chatbot?tab=Conversation`)
                      "
                      v-if="isShowMenu('conversation')"
                    >
                      <v-list-tile-action> </v-list-tile-action>
                      <v-list-tile-title>{{ $t('Conversation') }}</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                      :style="$route.query.tab === `Comment` ? 'background: #f44788;' : ''"
                      class="main-menu"
                      @click="
                        if ($route.path !== `/${currentLang}/chatbot?tab=Comment`)
                          $router.push(`/${currentLang}/chatbot?tab=Comment`)
                      "
                      v-if="isShowMenu('comment')"
                    >
                      <v-list-tile-action> </v-list-tile-action>
                      <v-list-tile-title>{{ $t('Comment to Inbox') }}</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                      :style="$route.query.tab === `LiveAuction` ? 'background: #f44788;' : ''"
                      class="main-menu"
                      @click="
                        if ($route.path !== `/${currentLang}/chatbot?tab=LiveAuction`)
                          $router.push(`/${currentLang}/chatbot?tab=LiveAuction`)
                      "
                      v-if="isShowMenu('LiveAuction')"
                    >
                      <v-list-tile-action> </v-list-tile-action>
                      <v-list-tile-title>{{ $t('live_auction') }}</v-list-tile-title>
                    </v-list-tile>

                    <template
                      v-if="
                        !selectedBot.pagerole ||
                          (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                      "
                    >
                      <v-list-tile
                        :style="$route.query.tab === `Training` ? 'background: #f44788;' : ''"
                        class="main-menu"
                        @click="
                          if ($route.path !== `/${currentLang}/chatbot?tab=Training`)
                            $router.push(`/${currentLang}/chatbot?tab=Training`)
                        "
                        v-if="isShowMenu('training')"
                      >
                        <v-list-tile-action> </v-list-tile-action>
                        <v-list-tile-title>{{ $t('Training') }}</v-list-tile-title>
                      </v-list-tile>
                    </template>

                    <v-list-tile
                      :style="$route.query.tab === `Calendar` ? 'background: #f44788;' : ''"
                      class="main-menu"
                      @click="
                        if ($route.path !== `/${currentLang}/chatbot?tab=Calendar`)
                          $router.push(`/${currentLang}/chatbot?tab=Calendar`)
                      "
                      v-if="isShowMenu('calendar') && selectedBot.selected_presets === '115'"
                    >
                      <v-list-tile-action> </v-list-tile-action>
                      <v-list-tile-title>{{ $t('calendar_reservation') }}</v-list-tile-title>
                    </v-list-tile> -->

                  <v-list-tile
                    class="main-menu"
                    :to="'/' + $i18n.locale() + '/broadcast'"
                    v-if="isShowMenu('broadcast')"
                  >
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/megaphone.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Broadcast') }}</v-list-tile-title>
                  </v-list-tile>
                  <template
                    v-if="$store.state.livepage.includes(selectedBot.pageid) && isShowMenu('live')"
                  >
                    <v-list-tile :to="'/' + $i18n.locale() + '/live'" class="main-menu">
                      <v-list-tile-action>
                        <v-img
                          style="max-width: 23px"
                          src="/static/img/assets/sidebar/live.svg"
                        ></v-img>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ $t('Live') }}</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <template
                    v-if="
                      ['ecommercebasic', 'adminperform'].includes(selectedBot.theme) &&
                        isShowMenu('template')
                    "
                  >
                    <v-list-tile :to="'/' + $i18n.locale() + '/template'" class="main-menu">
                      <v-list-tile-action>
                        <v-img
                          style="max-width: 23px"
                          src="/static/img/assets/sidebar/shop.svg"
                        ></v-img>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ $t('Shop/Salepage') }}</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <template v-else-if="isShowMenu('template')">
                    <v-list-tile :to="'/' + $i18n.locale() + '/template'" class="main-menu">
                      <v-list-tile-action>
                        <v-img
                          style="max-width: 23px"
                          src="/static/img/assets/sidebar/plugin.svg"
                        ></v-img>
                      </v-list-tile-action>
                      <v-list-tile-title>Plug-In</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    class="main-menu"
                    :to="'/' + $i18n.locale() + '/allinonechat'"
                    v-if="
                      (isShowMenu('livechat') && selectedBot.pagetype == 'enterprise') ||
                        $store.state.livechatPageIdList.includes(selectedBot.pageid) ||
                        selectedBot.pagetype != 'enterprise'
                    "
                  >
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/speech.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('All-in-one chat') }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="'/' + $i18n.locale() + '/growthtool'" class="main-menu">
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/growth.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('growth_tool') }}</v-list-tile-title>
                  </v-list-tile>
                  <!-- <template
                    v-if="
                      [
                        'localhost:3000',
                        'cms.zwiz.app',
                        'cms.zwiz.ai',
                        'cmstest.zwiz.ai',
                        'cmstest1.zwiz.ai',
                        'cmstest2.zwiz.ai',
                        'cmstest3.zwiz.ai',
                      ].includes(currentHost)
                    "
                  >
                    <v-list-tile
                      class="main-menu"
                      :to="'/' + $i18n.locale() + '/analytics'"
                      v-if="isShowMenu('analytics')"
                    >
                      <v-list-tile-action>
                        <v-img
                          style="max-width: 23px"
                          src="/static/img/assets/sidebar/analytics.svg"
                        ></v-img>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ $t('analytics') }}</v-list-tile-title>
                    </v-list-tile>
                  </template> -->
                  <template v-if="isShowMenu('analytics')">
                    <v-list-tile class="main-menu" :to="'/' + $i18n.locale() + '/analytics'">
                      <v-list-tile-action>
                        <v-img
                          style="max-width: 23px"
                          src="/static/img/assets/sidebar/analytics.svg"
                        ></v-img>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ $t('analytics') }}</v-list-tile-title>
                    </v-list-tile>
                  </template>
                </template>
                <template
                  v-if="
                    isShowMenu('upgrade') &&
                      (!selectedBot.pagerole ||
                        (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
                      selectedBot.pagetype != 'enterprise'
                  "
                >
                  <v-list-tile :to="'/' + $i18n.locale() + '/upgrade'" class="main-menu">
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/premium.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Upgrade to Premium Plan') }}</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="'/' + $i18n.locale() + '/partner'" class="main-menu">
                  <v-list-tile-action>
                    <v-img
                      style="max-width: 23px"
                      src="/static/img/assets/sidebar/plugin.svg"
                    ></v-img>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ $t('Plugin') }}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :to="'/' + $i18n.locale() + '/adssimulator'" class="main-menu">
                  <v-list-tile-action>
                    <v-img
                      style="max-width: 23px"
                      src="/static/img/assets/sidebar/mailbox.svg"
                    ></v-img>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ $t('messenger_ads_simulator') }}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  v-if="account_package.includes('advanced')"
                  :to="'/' + $i18n.locale() + '/beacon'"
                  class="main-menu"
                >
                  <v-list-tile-action>
                    <v-img
                      style="max-width: 23px"
                      src="/static/img/assets/sidebar/mailbox.svg"
                    ></v-img>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ $t('Beacon') }}</v-list-tile-title>
                </v-list-tile>

                <v-divider />
                <template
                  v-if="
                    !selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                >
                  <v-list-tile
                    :to="'/' + $i18n.locale() + '/billing'"
                    v-if="isShowMenu('billing')"
                    class="main-menu"
                  >
                    <v-list-tile-action>
                      <v-img
                        style="max-width: 23px"
                        src="/static/img/assets/sidebar/setting.svg"
                      ></v-img>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ $t('Setting') }}</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile @click="logout" class="main-menu">
                  <v-list-tile-action>
                    <v-img
                      style="max-width: 23px"
                      src="/static/img/assets/sidebar/sign-out.svg"
                    ></v-img>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ $t('Sign Out') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </div>
          </div>
        </v-navigation-drawer>
        <!-- </v-navigation-drawer> -->
        <v-content>
          <div style="position: relative" class="thishiw">
            <div class="alert-header alert-warning" v-if="!selectedBot.status" role="alert">
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <!-- <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    /> -->
                    <img src="/static/img/assets/icon/z-04.png" width="60px" alt="" />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong">{{ $t('Warning!') }}</div>
                    {{ $t('If you want to test, please activate your bot') }}
                    <a href="javascript:void(0);" @click="toggleBotStatus">
                      {{ $t('Click for starting your Bot') }}
                    </a>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div
              style="background: #f88b57"
              class="alert-header alert-warning"
              role="alert"
              v-if="
                !selectedBot.line_modular_botid &&
                  selectedBot.packages.includes('line') &&
                  !getPackageType().includes('advanced')
              "
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs3 sm1 class="text-xs-center">
                    <!-- <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    /> -->
                    <img src="/static/img/assets/icon/slide-10.png" width="60px" alt="" />
                  </v-flex>
                  <v-flex xs7 sm10 style="align-self: center">
                    <div class="strong">{{ $t('Warning!') }}</div>
                    {{
                      $t(
                        'According to the usage of Premium package, your chatbot will no longer be able to connect with LINE OA after the expiration date. Please upgrade your package to Advanced to connect with LINE OA latest version.'
                      )
                    }}
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div
              class="alert-header alert-warning"
              role="alert"
              v-if="expriedTime > 0 && expriedDate <= 7 && showAlertExpiredPackage"
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                    {{ $t('Your package will be expired in') }}
                    <template v-if="expriedTime > 0">
                      <countdown :time="expriedTime * 1000">
                        <template slot-scope="props">
                          <template v-if="props.days">
                            {{ props.days }}
                            <span class="small">{{ $t('Days') }}</span>
                          </template>
                          <template v-else-if="props.hours > 0">
                            {{ props.hours }}
                            <span class="small">{{ $t('Hours') }}</span>
                          </template>
                          <template v-else-if="props.minutes > 0">
                            {{ props.minutes }}
                            <span class="small">{{ $t('Minutes') }}</span>
                          </template>
                          <template v-else>
                            {{ props.seconds }}
                            <span class="small">{{ $t('Seconds') }}</span>
                          </template>
                        </template>
                      </countdown>
                      <!-- {{expriedTime}}  -->
                    </template>
                    <template v-if="selectedBot.pagetype != 'enterprise'">
                      <a
                        v-if="account_package.includes('advanced')"
                        href="https://m.me/zwizai?ref=lineoaadvanced"
                        >{{ $t('click here to extent your package') }}</a
                      >
                      <router-link :to="'/' + $i18n.locale() + '/upgrade'" v-else>{{
                        $t('click here to extent your package')
                      }}</router-link>
                    </template>
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn
                      flat
                      fab
                      small
                      dark
                      @click="$store.dispatch('clearAlert', 'expriedPackage')"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div
              class="alert-header alert-warning grey"
              role="alert"
              v-if="isPremiumExpired && showAlertExpiredPremium"
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <!-- <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    /> -->
                    <img src="/static/img/assets/icon/z-11.png" width="60px" alt="" />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                    {{
                      $t('Your premium package has expired, click here to continue this package')
                    }}
                    <template v-if="expriedTime > 0">
                      <countdown :time="expriedTime * 1000">
                        <template slot-scope="props">
                          <template v-if="props.days">
                            {{ props.days }}
                            <span class="small">{{ $t('Days') }}</span>
                          </template>
                          <template v-else-if="props.hours > 0">
                            {{ props.hours }}
                            <span class="small">{{ $t('Hours') }}</span>
                          </template>
                          <template v-else-if="props.minutes > 0">
                            {{ props.minutes }}
                            <span class="small">{{ $t('Minutes') }}</span>
                          </template>
                          <template v-else>
                            {{ props.seconds }}
                            <span class="small">{{ $t('Seconds') }}</span>
                          </template>
                        </template>
                      </countdown>
                      <!-- {{expriedTime}}  -->
                    </template>
                    <template v-if="selectedBot.pagetype != 'enterprise'">
                      <a
                        target="_blank"
                        v-if="account_package.includes('advanced')"
                        href="https://m.me/zwizai?ref=lineoaadvanced"
                        >{{ $t('click here to extent your package') }}</a
                      >
                      <a target="_blank" v-else @click="$router.push('Upgrade')">{{
                        $t('click here to extent your package')
                      }}</a>
                    </template>
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn
                      flat
                      fab
                      small
                      dark
                      @click="$store.dispatch('clearAlert', 'expriedPremium')"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div
              class="alert-header alert-line"
              v-if="!selectedBot.packages.includes('line') && showAlertLine && false"
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/line.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong">{{ $t('Line Chatbot is available!') }}</div>
                    {{ $t('Connect with line now') }}
                    <a href="https://blog.zwiz.ai/tutorial-7-เชื่อม-line/" target="_blank">
                      {{ $t('read_tutorial') }}
                    </a>
                    {{ $t('and') }}
                    <router-link :to="'/' + currentLang + '/billing?go=line'">
                      {{ $t('Go to setup') }}
                    </router-link>
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn flat fab small dark @click="$store.dispatch('clearAlert', 'line')">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div
              class="alert-header alert-warning red"
              v-if="
                selectedBot.facebook_status &&
                  selectedBot.statustoken === false &&
                  selectedBot.facebook_page_id
              "
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <!-- <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    /> -->
                    <img src="/static/img/assets/icon/z-03.png" width="60px" alt="" />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong">{{ $t('Hey! Your chatbot has connection error.') }}</div>
                    <div class="my-2">
                      <a @click="openFacebookUri" style="text-decoration: none;">
                        <v-btn
                          class="py-1"
                          style="height: 100%; border-radius: 20px 20px 20px 20px !important;"
                        >
                          <div style="color: #3b5998;text-transform: none !important;">
                            <i
                              class="fab fa-facebook-square mb-2 mr-2"
                              style="font-size: 1.3rem;color: #3b5998;"
                            ></i>
                            {{ $t('click_to_login_fb') }}
                          </div>
                        </v-btn>
                      </a>
                      {{ $t('or') }}
                      <a
                        target="blank"
                        href="https://blog.zwiz.ai/%E0%B8%9A%E0%B8%AD%E0%B8%97%E0%B8%A1%E0%B8%9B%E0%B8%8D%E0%B8%AB%E0%B8%B2%E0%B9%83%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%8A%E0%B8%AD%E0%B8%A1%E0%B8%95%E0%B8%AD/"
                        >{{ $t('click_for_more_information') }}</a
                      >
                    </div>
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn flat fab small dark @click="$store.dispatch('clearAlert', 'line')">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div
              v-if="
                showAds &&
                  selectedBot.pagetype != 'enterprise' &&
                  ['Upgrade', 'chatbot'].includes($route.name)
              "
            >
              <v-carousel hide-delimiters height="auto">
                <v-carousel-item>
                  <div @click="openLink('https://zwiz.app/')" style="cursor: pointer">
                    <v-img src="/static/img/bnsso-03.jpg"></v-img>
                    <v-btn
                      @click.stop="closeAds"
                      depressed
                      icon
                      style="background-color: orange; position: absolute; right: 2px; top: 2px"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                </v-carousel-item>
                <v-carousel-item>
                  <div
                    @click="openLink('https://blog.zwiz.ai/google-messages?utm_source=Banner')"
                    style="cursor: pointer"
                  >
                    <v-img src="/static/img/googleBanner.png"></v-img>
                    <v-btn
                      @click.stop="closeAds"
                      depressed
                      icon
                      style="background-color: orange; position: absolute; right: 2px; top: 2px"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </div>
          </div>

          <slot></slot>
        </v-content>

        <app-footer />
      </template>
    </div>

    <template v-if="!$store.state.loadingWelcome && $router.history.current.name != 'allinonechat'">
      <modal-welcome></modal-welcome>
      <div style="height: 100px"></div>
    </template>
    <div
      class="caption pa-1"
      v-if="isDev && selectedBot"
      style="position: fixed; bottom: 0; right: 0; background: #00000020"
    >
      Pageid: {{ selectedBot.pageid }}
    </div>
    <v-dialog v-model="modalDialog" persistent scrollable max-width="1000px">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="modalDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="text-xs-center">
            <h1>{{ $t('conditions_expired') }}</h1>
          </div>
          <span>{{ $t('conditions_expired2') }} </span>
          <template>
            <div
              class="mt-3 pa-2"
              style="border: 0px solid #000; border-radius: 10px; overflow: auto"
            >
              <table class="table">
                <tr>
                  <th style="border: solid 1px">{{ $t('Topics') }}</th>
                  <th style="border: solid 1px">
                    {{ $t('before_expires') }}
                  </th>
                  <th style="border: solid 1px">
                    {{ $t('after_expired') }}
                  </th>
                </tr>
                <tr>
                  <th style="border: solid 1px">{{ $t('Conversation') }}</th>
                  <td style="border: solid 1px">
                    <tr>
                      <td>
                        {{ $t('conversation_expired1') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ $t('conversation_expired2') }}
                      </td>
                    </tr>
                  </td>

                  <td style="border: solid 1px">
                    <tr style="display: block">
                      <td>
                        {{ $t('conversation_expired3') }}
                      </td>
                    </tr>
                    <tr style="display: block" class="">
                      {{
                        $t('conversation_expired4')
                      }}
                    </tr>
                    <tr style="display: block">
                      <td>{{ $t('conversation_expired5') }}</td>
                    </tr>
                    <tr style="display: block">
                      {{
                        $t('conversation_expired6')
                      }}
                    </tr>
                  </td>
                </tr>
                <tr>
                  <th style="border: solid 1px">{{ $t('Reply Comment') }}</th>
                  <td style="border: solid 1px">
                    <tr>
                      <td>
                        {{ $t('reply_comment_expired1') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ $t('reply_comment_expired2') }}
                      </td>
                    </tr>
                  </td>

                  <td style="border: solid 1px">
                    <tr>
                      <td>
                        {{ $t('reply_comment_expired3') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ $t('reply_comment_expired4') }}
                      </td>
                    </tr>
                  </td>
                </tr>
                <tr>
                  <th style="border: solid 1px">{{ $t('Tag/Status') }}</th>
                  <td style="border: solid 1px">
                    {{ $t('tag_status_expired1') }}
                  </td>

                  <td style="border: solid 1px">
                    {{ $t('tag_status_expired2') }}
                  </td>
                </tr>
                <tr>
                  <th style="border: solid 1px">{{ $t('shopservice') }}</th>
                  <td style="border: solid 1px">
                    {{ $t('shop_service_expired1') }}
                  </td>

                  <td style="border: solid 1px">
                    <tr style="display: block">
                      {{
                        $t('shop_service_expired2')
                      }}
                    </tr>
                    <tr style="display: block" class="mt-3">
                      {{
                        $t('shop_service_expired3')
                      }}
                    </tr>
                  </td>
                </tr>
                <tr>
                  <th style="border: solid 1px">{{ $t('Sale Page') }}</th>
                  <td style="border: solid 1px">
                    {{ $t('salepage_expired1') }}
                  </td>

                  <td style="border: solid 1px">
                    {{ $t('salepage_expired2') }}
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isActiveModalProfile" width="500" z-index="9999" persistent>
      <v-card>
        <v-card-text>
          <p class="title">{{ $t('Link image url') }}</p>
          <div class="wrapper-avatar-profile">
            <v-avatar class="avatar-profile mx-auto" :size="mini ? '120px' : '200px'">
              <img class="responsive-img circle cover" alt :src="urlPreview" />
            </v-avatar>
            <v-btn color="primary" @click="handleUpdateProfile" depressed>
              {{ $t('select file to upload') }}
            </v-btn>
          </div>
          <div class="d-flex" style="column-gap: 4px">
            <v-btn outline color="primary" depressed @click="cancelUpload">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn :disabled="!file" color="primary" depressed @click="uploadProfile">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import header from '@/components/elements/header'
import footer from '@/components/elements/footer'
import dropdown from 'vue-dropdowns'
import dayjs from 'dayjs'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalWelcome from '@/components/elements/ModalWelcome'
import config from '@/config'
import ViewPackage from '@/components/view/setting/ViewPackage'
import SocialBadge from '@/components/elements/SocialBadge'

import api from '@/api'

export default {
  // name: "dashboard",
  components: {
    'app-header': header,
    'app-footer': footer,
    dropdown,
    ViewPackage,
    ModalDialog,
    ModalWelcome,
    SocialBadge
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome'
    }),
    isZwizAdmin() {
      try {
        return this.$store.state.userid.includes('zwiz') && this.$store.state.loginType == 'admin'
      } catch (error) {
        return false
      }
    },
    isDev() {
      return process.env.NODE_ENV === 'development'
    },
    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#ED1E79'
    },
    isPremiumExpired() {
      let expire = this.$store.state.selectedBot.expireat
      let today = dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let register = this.$store.state.selectedBot.registerat
      return expire > register && expire < today
    },
    showUpsell1: function() {
      if (this.$store.getters.showAlert('upsell1') >= 0) {
        var alert = this.$store.getters.showAlert('upsell1')
        return alert.show
      } else {
        return true
      }
    },
    showAlertLine: function() {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function() {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPremium: function() {
      if (this.$store.getters.showAlert('expriedPremium') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPremium')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function() {
      // let options = []
      // let vm = this
      // $.each(vm.botlist, function (index, val) {
      //   if (val.pageid != vm.selectedBot.pageid) {
      //     options.push({ name: val.pagename, value: val.pageid })
      //   }
      // })

      return this.botlist
        .map(el => {
          if (el.pageid == this.selectedBot.pageid) return null
          return { name: el.pagename, value: el.pageid }
        })
        .filter(el => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    },
    showBadge() {
      const vm = this
      return vm.isShowBadge === '0'
    }
  },
  data: function() {
    return {
      modalDialog: false,
      resetBadge: '1',
      isShowBadge: '0',
      windowTop: 0,
      group_open: false,
      drawer: true,
      mini: false,
      right: null,
      activeChatbot: false,
      // drawer: null,
      showAds: true,
      autostart: false,
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish')
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null,
      currentHost: window.location.host,
      account_package: this.getPackageType(),
      alertExp: false,
      alertExpSet: false,
      facebookUri: '',
      file: null,
      urlPreview: '',
      isActiveModalProfile: ''
    }
  },
  beforeDestroy() {
    document.getElementById('navigation').addEventListener('scroll', this.onScroll)
  },
  mounted: async function() {
    const vm = this
    if (
      vm.selectedBot.expriedDate <= 7 &&
      (vm.selectedBot.advancedExpriedDate <= 7 || vm.selectedBot.businessExpriedDate <= 7)
    ) {
      vm.alertExpSet = true
    }
    if (vm.account_package.length === 0) {
      vm.alertExp = true
    }
    if (sessionStorage.getItem('navigation')) {
      this.windowTop = sessionStorage.getItem('navigation')
      document.getElementById('navigation').scrollTop = this.windowTop
    }
    document.getElementById('navigation').addEventListener('scroll', this.onScroll)
    this.$validator.localize(this.currentLang)
    let packages = this.getPackageType()
    // console.log(this.$route.query)

    if (packages.includes('advanced') && this.$route.query.notify_free_premium) {
      this.$swal.fire({
        title: this.$t('7 days Full Trial on ADVANCED Package'),
        type: 'success',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
    }

    var now = dayjs()
    var expriedDate = dayjs(this.$store.state.selectedBot.expireat)
    this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))

    this.selectedOption = {
      name: this.selectedBot.pagename,
      value: this.selectedBot.pageid
    }
    try {
      if (typeof this.$store.state.setting === 'undefined') {
        var contents = await this.getSetting()
        this.$store.dispatch('updateSetting', contents)
      }
    } catch (error) {
      console.error(error)
    }

    try {
      if (typeof this.$store.state.welcomeMessage2 === 'undefined') {
        var welcomeMessage2 = await this.getWelcomeMessage2()
        this.$store.dispatch('updateWelcomeMessage2', welcomeMessage2)
      }
      if (typeof this.$store.state.welcomeMessage === 'undefined') {
        var welcomeMessage = await this.getWelcomeMessage()
        this.$store.dispatch('updateWelcomeMessage', welcomeMessage)
      }
      await this.$nextTick()
      this.$store.commit('SET_LOADING_WELCOME', false)
    } catch (error) {
      console.error(error)
    }

    // this.$tours['myTour'].start()

    if (this.showModalWelcome) {
      // vm.openTutorial()
    }
    const fb_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }/autofblogin`
    let query = []
    query.push(`lang=${vm.currentLang}`)
    for (const key in vm.$route.query) {
      if (key != 'state') query.push(`${key}=${vm.$route.query[key]}`)
    }
    vm.facebookUri = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${config.appid}&scope=${
      config.fb_scope
    }${
      localStorage.getItem('allowed_business_management') ? ',business_management' : ''
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (query.length > 0) vm.facebookUri = vm.facebookUri + `&state={${query.join(',')}}`

    vm.instagramUri = `https://www.facebook.com/v13.0/dialog/oauth?client_id=${
      config.appid
    }&display=page&extras={"setup":{"channel":"IG_API_ONBOARDING"}}&redirect_uri=${encodeURIComponent(
      fb_redirect_uri
    )}&scope=${
      config.fb_scope
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (query.length > 0) vm.instagramUri = vm.instagramUri + `&state={${query.join(',')}}`
  },
  created: function() {
    const vm = this
    if (
      localStorage.getItem('isShowBadge') === null ||
      localStorage.getItem('isShowBadge') === vm.resetBadge
    ) {
      vm.isShowBadge = vm.resetBadge
    } else {
      vm.isShowBadge = '0'
    }
    if (sessionStorage.getItem('group_open') === 'true') {
      vm.group_open = true
    }
    if (vm.$vuetify.breakpoint.xs || vm.$vuetify.breakpoint.sm) {
      vm.drawer = false
    }
    if (
      localStorage.getItem('hideads') &&
      localStorage.getItem('hideads').includes(vm.selectedBot.pageid)
    ) {
      vm.showAds = false
    }
  },
  methods: {
    closeBadge() {
      const vm = this
      localStorage.setItem('isShowBadge', vm.resetBadge)
      vm.isShowBadge = vm.resetBadge
    },
    onScroll(e) {
      this.windowTop = document.getElementById('navigation').scrollTop
      sessionStorage.setItem('navigation', this.windowTop)
    },
    group_event() {
      // this.group_open = !this.group_open
      // sessionStorage.setItem('group_open', this.group_open)
    },
    clickAdsRichmanu() {
      window.open(`https://tinyurl.com/ycgsqluh`)
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    clickAds2() {
      window.open(
        `https://zwiz.ai/${this.currentLang}/ads?utm_source=Banner&pageid=${this.selectedBot.pageid}`
      )
    },
    closeAds() {
      var closeads = ''
      if (
        localStorage.getItem('hideads') &&
        !localStorage.getItem('hideads').includes(this.selectedBot.pageid)
      ) {
        closeads = localStorage.getItem('hideads') + ',' + this.selectedBot.pageid
      } else {
        closeads = this.selectedBot.pageid
      }
      localStorage.setItem('hideads', closeads)
      this.showAds = false
    },
    isShowMenu(menu) {
      if (menu == 'comment') {
        return this.selectedBot.packages.includes('facebook')
      } else if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
        return this.$store.state.menubypageid[this.selectedBot.pageid].includes(menu)
      } else return true
    },
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },

    clickAds() {
      const vm = this
      var prefix = window.location.hostname == 'cms.zwiz.app' ? 'z_' : ''
      vm.$gtag.event(`${prefix}banner_free_richmenu`, {
        event_category: vm.selectedBot.pagename
      })
      if (
        localStorage.getItem('loginBy') &&
        typeof localStorage.getItem('loginBy') !== 'undefined'
      ) {
        vm.$gtag.event(`${prefix}banner_free_richmenu_${localStorage.getItem('loginBy')}`, {
          event_category: vm.selectedBot.pagename
        })
      }
      window.open(`https://m.me/361231620965547?ref=บริการเสริมและริชเมนู`)
    },
    logout: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login').catch(() => {})
            } else {
              if (vm.$store.state.privilege.role === 'admin') {
                vm.$router.push('/' + vm.currentLang + '/iconkaset').catch(() => {})
              } else if (vm.$store.state.userid === 'metateam') {
                vm.$router.push('/' + vm.currentLang + '/meta').catch(() => {})
              } else {
                vm.$router.push('/' + vm.currentLang + '/nigol').catch(() => {})
              }
            }
            vm.$store.dispatch('logout', null).then()
          }
        })
    },
    selectBot: function(page) {
      var vm = this
      vm.$store.dispatch('loading')
      $.each(vm.botlist, function(index, bot) {
        if (page.value === bot.pageid) {
          vm.$store.dispatch('selectBot', bot)
        }
      })
      location.reload()
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getSetting(data, function(error, response) {
          if (error) {
            reject(error)
          }

          var contents = {}
          $.each(response.data, function(index, val) {
            contents[val.contenttype] = val
          })
          resolve(contents)
        })
      })
    },
    getWelcomeMessage2: function() {
      let vm = this
      let res = null
      let data = {
        pageid: vm.selectedBot.pageid,
        intent_name: '{welcome}',
        search_intent: ''
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            $.each(response.data, function(index, val) {
              var intent = val
              if (intent.intentname == '{welcome}') {
                res = intent
              }
            })
          }
          resolve(res)
        })
      })
    },
    getWelcomeMessage: function(callback) {
      let vm = this
      if (!vm.selectedBot) return false
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      var messages = null
      var type = 'json'
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, function(error, response) {
          if (error) {
            reject(error)

            return
          }
          if (response.data) {
            type = response.data.type
            if (type === 'message') {
              messages = [
                [
                  {
                    text: response.data.message_text,
                    type: 'text'
                  }
                ]
              ]
            } else if (type === 'generic') {
              messages = [[]]
              if (
                response.data.message &&
                typeof response.data.message === 'object' &&
                response.data.message.length > 0
              ) {
                $.each(response.data.message, function(index, val) {
                  generics[index] = val
                })

                messages[0][0] = {
                  type: 'generic',
                  data: generics,
                  ratio: response.data.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              }
            } else {
              if (vm.isJsonParseable(response.data.message)) {
                messages = JSON.parse(response.data.message)
              }
            }
            type = 'json'
          }
          resolve({
            type: type,
            message: message,
            generics: generics,
            messages: messages
          })
        })
      })
    },
    toggleBotStatus: async function() {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.botStatus = bot.status
      this.$store.dispatch('loading')
    },
    openFacebookUri() {
      const vm = this
      window.open(vm.facebookUri, '_self')
    },
    handleUploadProfile() {
      this.urlPreview =
        this.selectedBot.pagelogo ||
        'https://graph.facebook.com/' +
          this.selectedBot.pageid +
          '/picture?width=100&height=100&SameSite=None'

      this.isActiveModalProfile = true
    },
    handleUpdateProfile() {
      this.$refs.uploadProfile.click()
    },
    cancelUpload() {
      this.isActiveModalProfile = false
      this.$nextTick(() => {
        this.file = null
        this.urlPreview = ''
      })
    },
    async saveProfile(pagelogo) {
      const { success } = await this.put(`page/${this.selectedBot.pageid}/update-page-config`, {
        pagelogo
      })
      if (success) {
        this.$store.dispatch('updateBotDetail')
        this.$store.dispatch('loading')
        this.cancelUpload()
      }
    },
    uploadProfile() {
      this.$store.dispatch('loading')
      const payload = {
        name: this.file.name,
        type: this.file.type,
        file: this.file
      }
      api.getSignedRequest(payload, (error, url) => {
        if (error) {
          console.error(error)
          this.$store.dispatch('loading')
          return
        }
        this.saveProfile(encodeURI(url))
      })
    },
    handlePreviewProfile(event) {
      if (event) {
        this.$store.dispatch('loading')
        setTimeout(() => {
          this.file = event.target.files[0]
          this.urlPreview = URL.createObjectURL(event.target.files[0])
          this.isActiveModalProfile = true
          this.$refs.uploadProfile.value = ''
          this.$store.dispatch('loading')
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss">
.menu.default {
  background: transparent linear-gradient(40deg, rgb(235, 181, 33) 0%, rgb(247, 67, 154) 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 30px 30px 30px 0px;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
      color: #fff;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-user {
        background-image: url('/static/img/assets/sidebar/user.svg');
      }

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-platformUpdate {
        background-image: url('/static/img/assets/sidebar/version.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }
      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h2,
h4,
h5,
h6 {
  color: var(--primary-color);
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
// .slide-fade-leave-active {
//   transition: all 0.3s cubic-bezier(1, 0.3, 0.3, 1);
// }
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.thishiw .v-carousel__controls {
  background: none;
}
.alertExpDate.active {
  animation-name: alertExp;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
}

.wrapper-avatar-profile {
  display: flex;
  width: fit-content;
  flex-direction: column;
  margin: 16px auto;
}

.avatar-profile {
  position: relative;
  overflow: hidden;
  &.upload:hover {
    cursor: pointer;
    .avatar-profile-upload {
      width: 100%;
      height: 100%;
      pointer-events: auto;
    }
  }
  .avatar-profile-upload {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 0px;
    height: 0px;
    border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.4);
    transition: all cubic-bezier(0.075, 0.82, 0.165, 1);
    pointer-events: none;
    overflow: hidden;
  }
}
@keyframes alertExp {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Main.vue